module.exports = __webpack_public_path__ + "img/h2-2.2e7082d0.png";